/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-trade': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<g _fill="#595959" fill-rule="nonzero"><path pid="0" d="M7 0a7 7 0 110 14A7 7 0 017 0zm0 1a6 6 0 100 12A6 6 0 007 1z"/><path pid="1" d="M9.603 3.856l-1.736 3.2h.969c.069 0 .125.057.125.125v.467a.125.125 0 01-.125.125H7.555v.649h1.28c.07 0 .126.056.126.125v.467a.125.125 0 01-.125.125H7.555v1.064a.125.125 0 01-.125.125H6.58a.125.125 0 01-.125-.125V9.14H5.18a.125.125 0 01-.125-.125v-.467c0-.069.056-.125.125-.125h1.276v-.649H5.18a.125.125 0 01-.125-.125v-.467c0-.068.056-.125.125-.125h.96l-1.743-3.2a.126.126 0 01.11-.186h.948c.047 0 .09.027.11.07l1.416 2.812h.053L8.45 3.739a.125.125 0 01.11-.069h.93c.07 0 .126.057.126.125a.103.103 0 01-.013.061z"/></g>'
  }
})
